import { render, staticRenderFns } from "./addExaminePkg.vue?vue&type=template&id=2469e408&scoped=true&"
import script from "./addExaminePkg.vue?vue&type=script&lang=js&"
export * from "./addExaminePkg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2469e408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2469e408')) {
      api.createRecord('2469e408', component.options)
    } else {
      api.reload('2469e408', component.options)
    }
    module.hot.accept("./addExaminePkg.vue?vue&type=template&id=2469e408&scoped=true&", function () {
      api.rerender('2469e408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/examine/components/addExaminePkg.vue"
export default component.exports